import React from 'react';
import { useListBoxSection } from '@react-aria/listbox';
import { ListSection, ListSectionLabel } from './list-box.styles.js';
export const ListBoxSection = ({ children, isUsingCheckbox, title, }) => {
    const { itemProps, headingProps, groupProps } = useListBoxSection({
        heading: title,
    });
    if (React.Children.count(children) === 0) {
        return null;
    }
    return (React.createElement("li", { ...itemProps },
        React.createElement(ListSectionLabel, { ...headingProps, color: 'secondary', fontWeight: 'emphasised', fontSize: 'xs' }, title),
        React.createElement(ListSection, { ...groupProps, isUsingCheckbox: isUsingCheckbox }, children)));
};
//# sourceMappingURL=list-box-section.component.js.map